// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__wDXIc","content":"GlobalSearch_content__2zrKH"};